import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
  sendPasswordResetEmail,
  sendEmailVerification,
} from "firebase/auth";
import { auth } from "../config/firebase";

const login = async (email, password) => {
  try {
    const userCredentials = await signInWithEmailAndPassword(
      auth,
      email,
      password,
    );
    const user = userCredentials.user;
    return user;
  } catch {
    return false;
  }
};

const logout = async () => {
  try {
    await signOut(auth);
  } catch {
    return false;
  }
};

const registerUser = async (email, password) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password,
    );
    const user = userCredential.user;
    return user;
  } catch {
    return false;
  }
};

const registerUserWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  await signInWithPopup(auth, provider)
    .then((result) => {
      // This gives you a Google Access Token. You can use it to access the Google API.
      GoogleAuthProvider.credentialFromResult(result);
    })
    .catch((error) => {
      // Handle Errors here.
      console.error(error);
    });
};

const registerUserWithFacebook = async () => {
  const provider = new FacebookAuthProvider();
  await signInWithPopup(auth, provider)
    .then((result) => {
      // This gives you a Google Access Token. You can use it to access the Google API.
      FacebookAuthProvider.credentialFromResult(result);
    })
    .catch((error) => {
      // Handle Errors here.
      console.error(error);
    });
};

const sendResetPasswordEmail = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
  } catch (error) {
    console.error(`Error while sending reset password link ${error}`);
    return error;
  }
};

const sendVerificationEmail = async () => {
  const user = auth.currentUser;
  try {
    await sendEmailVerification(user);
  } catch (error) {
    console.error(`Error while sending email verification email ${error}`);
    return error;
  }
};

const observer = (callback) => onAuthStateChanged(auth, callback);

export {
  registerUser,
  login,
  logout,
  observer,
  registerUserWithGoogle,
  registerUserWithFacebook,
  sendResetPasswordEmail,
  sendVerificationEmail,
};
